/** Which Naturals portal hosts the engagement UI (nav + HQ-only features). */

export const ENTERPRISE_ENGAGEMENT_PARTNER_BASE = '/nyafaz-ep/partner/engagement';
export const ENTERPRISE_ENGAGEMENT_WORKSPACE_BASE = '/nyafaz-ep/workspace/engagement';
export const ENTERPRISE_ENGAGEMENT_DEFAULT_BASE = '/nyafaz-ep/engagement';
export const ENTERPRISE_PARTNER_OPS_APPOINTMENTS = '/nyafaz-ep/partner/operations/appointments';
export const ENTERPRISE_PARTNER_GUEST_APPOINTMENTS = '/nyafaz-ep/partner/guest/appointments';

function isPartnerOpsAppointmentsPath(path) {
  const p = String(path || '');
  return (
    p === ENTERPRISE_PARTNER_OPS_APPOINTMENTS ||
    p.startsWith(`${ENTERPRISE_PARTNER_OPS_APPOINTMENTS}/`) ||
    p === ENTERPRISE_PARTNER_GUEST_APPOINTMENTS ||
    p.startsWith(`${ENTERPRISE_PARTNER_GUEST_APPOINTMENTS}/`)
  );
}

export function getEngagementPortal() {
  if (typeof window === 'undefined') return 'standalone';
  const path = window.location.pathname || '';
  if (isPartnerOpsAppointmentsPath(path)) {
    return 'partner';
  }
  if (path.startsWith(ENTERPRISE_ENGAGEMENT_PARTNER_BASE) || path === `${ENTERPRISE_ENGAGEMENT_PARTNER_BASE}/`) {
    return 'partner';
  }
  if (path.startsWith(ENTERPRISE_ENGAGEMENT_WORKSPACE_BASE) || path === `${ENTERPRISE_ENGAGEMENT_WORKSPACE_BASE}/`) {
    return 'workspace';
  }
  if (path.startsWith('/nyafaz-ep/workspace/whatsapp')) {
    return 'workspace';
  }
  return 'standalone';
}

/** Workspace HQ or legacy standalone mount — not a franchise partner desk. */
export function isEngagementHqPortal() {
  return getEngagementPortal() !== 'partner';
}

/** HQ-only screens: AI docs, automation settings, message templates. */
export function canManageEngagementHqConfig() {
  return isEngagementHqPortal();
}

/** Instagram DM threads are listed beside WhatsApp on Conversations. */
export const SHOW_INSTAGRAM_CONVERSATIONS_BY_USERNAME = true;
